export default __webpack_public_path__ + "static/media/rect.28cbf684.png";